module.exports = __webpack_public_path__ + "image/ewm_dy.jpg";